'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const DirectionIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.959 11.3021L12.7071 3.05016C12.3166 2.65963 11.6834 2.65963 11.2929 3.05016L3.04094 11.3021C2.65041 11.6926 2.65041 12.3258 3.04094 12.7163L11.2929 20.9683C11.6834 21.3588 12.3166 21.3588 12.7071 20.9683L20.959 12.7163C21.3496 12.3258 21.3496 11.6926 20.959 11.3021Z",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.81 11.56L13.81 9.31V10.83H9.29004C8.33004 10.83 7.54004 11.62 7.54004 12.58V14.59H9.04004V12.58C9.04004 12.44 9.15004 12.33 9.29004 12.33H13.81V13.81L16.81 11.56Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpDirectionIcon = forwardRef(DirectionIcon);

export { VpDirectionIcon as default };
